
/**
  * Do not change! File was auto generate.
  *
  */
import { ReactElement, SVGProps } from 'react';
import { ReactComponent as DigitalResourcesIconComponent } from "./digital-resources-icon.svg";

export const DigitalResourcesIcon = (props: SVGProps<SVGSVGElement>): ReactElement => {
  return <DigitalResourcesIconComponent {...props} />;
};
